module.exports = __webpack_public_path__ + "static/media/user-login-ico.053848b1.png";